module.exports = ".router {\n  margin-top: 12%; }\n\n.jumbotron {\n  background-color: white; }\n\n.router {\n  -ms-flex-line-pack: center;\n      align-content: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main